import {
  Component,
  Input,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';

@Component({
    selector: 'pr-slide',
    templateUrl: './pr-slide.component.html',
    styleUrls: ['./pr-slide.component.scss'],
    standalone: false
})
export class PrSlideComponent implements OnInit {
  constructor() {}
  @Input() public label: string;

  @ViewChild(TemplateRef) template: TemplateRef<any>;

  ngOnInit() {}
}
